import { render, staticRenderFns } from "./OcaEditTabInformation.vue?vue&type=template&id=d972aea6&scoped=true&"
import script from "./OcaEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./OcaEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./OcaEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d972aea6",
  null
  
)

export default component.exports